<template>
  <v-dialog v-model="openedDialog" max-width="1000px" scrollable>
    <template #activator="{ on }">
      <strong v-if="textMode" class="terms-conditions-text" @click="on.click">Termos e condições.</strong>
      <mf-button v-else label="Consultar termos e condições" outlined icon="description" class="button" @click.native="on.click" />
    </template>

    <v-card>
      <v-card-title class="terms-conditions-dialog-title">
        <span>Termos e condições</span>
      </v-card-title>

      <v-card-text>
        <v-img v-if="banner" class="ma-2" contain height="200px" :src="banner" />
        <VueShowdown class="mt-1" :markdown="markdownText" />
        <slot />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <slot name="actions" />
        <mf-button outlined label="Fechar" @click="openedDialog = false" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { VueShowdown } from 'vue-showdown'
export default {
  name: 'MfMarkdownDialog',
  components: {
    VueShowdown,
  },
  props: {
    banner: {
      type: String,
      default: '',
    },
    markdownText: {
      type: String,
      required: true,
      default: '',
    },
    textMode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    openedDialog: false,
  }),
}
</script>

<style lang="scss" scoped>
.terms-conditions-dialog-title {
  font-size: 18px;
  color: $cinza-d10;
}

.terms-conditions-text {
  color: $marca-0-l40;
}

.button {
  display: block;
}

::v-deep .v-btn {
  width: 100% !important;
}
</style>
